import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=48f1ef04&scoped=true&"
import script from "./Invitation.vue?vue&type=script&lang=js&"
export * from "./Invitation.vue?vue&type=script&lang=js&"
import style0 from "./Invitation.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Invitation.vue?vue&type=style&index=1&id=48f1ef04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1ef04",
  null
  
)

component.options.__file = "Invitation.vue"
export default component.exports